export type DropInServiceTab = "setup" | "dashboard";

/**
 * Resolves the first `tab` query value. URLSearchParams#get deliberately uses
 * first-value semantics; the navigation model matches query params the same way.
 */
export function resolveDropInServiceTab(
  search: string | URLSearchParams,
): DropInServiceTab {
  const value =
    typeof search === "string"
      ? new URLSearchParams(search).get("tab")
      : search.get("tab");
  return value === "dashboard" ? "dashboard" : "setup";
}
